// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Cards Section Styles */
.main-cards-section {
  padding: 12px 0;
  background: #f8f9fa;
}

.main-cards-grid {
  display: flex;
  gap: 16px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  overflow-x: auto;
}

/* Water Treatment Carousel */
.water-treatment-carousel {
  width: 500px;
  flex: 0 0 auto;
}

.water-treatment-carousel .slick-list {
  margin-bottom: 0;
}

/* Birthday Carousel */
.birthdays-carousel {
  width: 300px;
  flex: 0 0 auto;
  min-width: 280px;
}

.birthdays-carousel .slick-slider {
  position: relative;
}

.birthdays-carousel .slick-list {
  border-radius: 12px;
  overflow: hidden;
}

.water-treatment-carousel .slick-slider {
  position: relative;
}

.water-treatment-carousel .slick-list {
  border-radius: 12px;
  overflow: hidden;
}

/* Water Treatment Card */
.water-treatment-card {
  position: relative;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
  color: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;
  height: 380px;
  width: 100%;
}

.water-treatment-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, #000000 1.37%, rgba(0, 0, 0, 0) 78.02%);
}

.water-treatment-card:hover {
  transform: translateY(-2px);
}

.water-treatment-card .card-content {
  z-index: 1;
}

.water-treatment-card .card-content h3 {
  font-size: 28px;
  margin-bottom: 10px;
  color: white;
}

.water-treatment-card .card-content p {
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  max-width: 100%;
}

/* Carousel Modal Styles */
.carousel-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.carousel-modal-container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  width: 100%;
}

.carousel-modal-close {
  position: absolute;
  top: -50px;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-modal-close:hover {
  background: white;
}

/* Employee Cards Container */
.employee-card {
  background-color: white;
  display: flex;
  flex: 1 1;
  border-radius: 12px;
  height: 380px;
  min-width: 700px;
  overflow: visible;
}

.employee-card .birthdays-carousel,
.employee-card .new-joinee-carousel {
  flex: 1 1;
  border-right: 1px solid #e0e0e0;
  min-width: 180px;
  height: 100%;
}

.employee-card .birthdays-carousel .card,
.employee-card .new-joinee-carousel .card {
  border: none;
  border-radius: 0;
  height: 100%;
  background: none;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.employee-card .card {
  border-right: 1px solid #e0e0e0;
  background: none;
  padding: 15px;
  display: flex;
  flex-direction: column;
  border: none;
  border-radius: 0;
  flex: 1 1;
  min-width: 180px;
}

.employee-card .card:last-child {
  border-right: none;
}

.employee-card .card-dots {
  justify-content: center;
  margin-top: auto;
}

/* Individual Employee Cards */
.new-joinee-card,
.birthdays-card {
  text-align: center;
  width: 100%;
}

.leave-card {
  width: 100%;
}

.new-joinee-card h4,
.birthdays-card h4,
.leave-card h4 {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
}

/* Profile Info Styles */
.profile-info {
  text-align: center;
}

.profile-pic {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin: 0 auto 15px;
}

.profile-info h5 {
  font-size: 16px;
  font-weight: 600;
  color: #005aab;
  margin-bottom: 5px;
}

.profile-info p {
  font-size: 13px;
  color: #666;
  margin-bottom: 5px;
}

.joined-date {
  color: #0078d4 !important;
  font-weight: 500 !important;
}

/* Wish Button */
.wish-btn {
  background-color: #00aaff;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.wish-btn .icon-send {
  font-size: 16px;
}

.wish-btn:hover {
  background-color: #0088cc;
}

/* Calendar Styles */
.calendar {
  margin-bottom: 15px;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.calendar-header .month-year {
  font-weight: 600;
  color: #0078d4;
}

.calendar-header .nav-arrow {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0px;
  text-align: center;
  font-size: 12px;
  width: 100%;
  grid-auto-rows: minmax(30px, auto);
}

.calendar-grid .day-name {
  padding: 5px 2px;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #666;
}

.calendar-grid .day,
.calendar-grid .empty-day {
  padding: 5px;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 12px;
}

.day.today { 
  background-color: #0078d4; 
  color: white; 
  font-weight: bold;
}

.day.absent { 
  background-color: #28a745; 
  color: white; 
  font-weight: bold;
}

.day.present { 
  background-color: #e0f2e9; 
}

/* Leave Balance */
.leave-balance {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f9fa;
  border-radius: 10px;
  padding: 10px;
  margin-top: 15px;
}

/* Awards Container Styles */
.awards-container {
  min-height: 500px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
}

.awards-layout {
  position: relative;
  width: 100%;
  height: 500px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  overflow: hidden;
}

/* Central REAP Letters */
.reap-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 10px;
}

.reap-letter {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 24px;
  border-radius: 8px;
  position: relative;
}

.reap-letter span {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 8px;
  white-space: nowrap;
  font-weight: 600;
}

.reliability { background-color: #8B4513; }
.excellence { background-color: #0066CC; }
.agility { background-color: #8B4513; }
.perseverance { background-color: #2C3E50; }

/* Employee Award Styles */
.award-employee {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

.employee-image-container {
  position: relative;
  margin-bottom: 10px;
}

.employee-award-image {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  border: 2px solid #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.3s ease;
}

.employee-award-image:hover {
  transform: scale(1.1);
}

.employee-name-tooltip {
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  z-index: 10;
}

.employee-image-container:hover .employee-name-tooltip {
  opacity: 1;
}

.award-badge {
  background: #0078d4;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  max-width: 120px;
  word-wrap: break-word;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Connecting Lines */
.connecting-line {
  position: absolute;
  width: 2px;
  height: 40px;
  background: linear-gradient(to bottom, #0078d4, transparent);
  top: 70px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.6;
}

.connecting-line::before {
  content: '';
  position: absolute;
  width: 40px;
  height: 2px;
  background: linear-gradient(to right, #0078d4, transparent);
  top: 20px;
  left: -19px;
}

/* Empty Award Placeholders */
.empty-award {
  position: absolute;
  z-index: 1;
}

.empty-placeholder {
  width: 60px;
  height: 60px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background: rgba(255,255,255,0.5);
}

/* Company Policies Styles */
.policies-container {
  width: 100%;
}

.policies-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding-left: 20px;
  margin-bottom: 20px;
}

.policy-card {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.policy-card:hover {
  opacity: 0.8;
}

.policy-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 0;
}

.policy-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 6px;
  flex-shrink: 0;
}

.policy-icon-img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.policy-header h5 {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0;
  line-height: 1.3;
  flex: 1 1;
}

.policy-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 44px;
}

.policy-meta {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.policy-category {
  background: #e3f2fd;
  color: #1976d2;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
}

.policy-type {
  color: #666;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.policy-date {
  color: #888;
  font-size: 11px;
}

/* View All Button Styles */
.view-all-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.view-all-btn {
  background: #0078d4;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-all-btn:hover {
  background: #106ebe;
  transform: translateY(-1px);
}

/* Responsive Design for Policies Grid */
@media (max-width: 1024px) {
  .policies-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .policies-grid {
    grid-template-columns: 1fr;
  }
  
  .policy-card {
    min-height: 120px;
  }
}

/* Updates Container */
.updates-container {
  width: 100%;
}

/* Snippets Styles - Same as Updates */
.snippets-container {
  width: 100%;
}

.snippets-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 20px;
  padding-left: 20px;
  margin-bottom: 20px;
}

.snippet-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 8px 0;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.snippet-item:hover {
  background-color: #f8f9fa;
}

.snippet-img {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}

.snippet-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.snippet-content h5 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 4px 0;
  line-height: 1.3;
}

.snippet-content p {
  font-size: 14px;
  color: #666;
  margin: 0 0 8px 0;
  line-height: 1.4;
}

.snippet-meta {
  display: flex;
  gap: 8px;
  align-items: center;
}

.snippet-type {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.snippet-type.image {
  background: #e3f2fd;
  color: #1976d2;
}

.snippet-type.video {
  background: #fce4ec;
  color: #c2185b;
}

.snippet-type.ebook {
  background: #f3e5f5;
  color: #7b1fa2;
}

.snippet-date {
  color: #888;
  font-size: 12px;
}

/* Media Modal Styles */
.media-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.media-modal-container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: transparent;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.media-modal-container.video-modal {
  background: #000;
}

.media-modal-close {
  position: absolute;
  top: -50px;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  z-index: 2001;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.media-modal-close:hover {
  background: white;
}

.modal-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
}

.modal-video {
  width: 80vw;
  height: 45vw;
  max-width: 1200px;
  max-height: 675px;
  min-width: 640px;
  min-height: 360px;
}

.modal-caption {
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 16px;
  margin-top: 10px;
  border-radius: 8px;
}

.modal-caption h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
}

.modal-caption p {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  opacity: 0.9;
}

/* Responsive Snippets Grid */
@media (max-width: 1024px) {
  .snippets-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px 16px;
  }
}

@media (max-width: 768px) {
  .snippets-list {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  
  .snippet-item {
    padding: 6px 0;
  }
}

/* Responsive Modal */
@media (max-width: 768px) {
  .modal-video {
    width: 90vw;
    height: 50.6vw;
    min-width: 320px;
    min-height: 180px;
  }
  
  .media-modal-close {
    top: -40px;
    width: 35px;
    height: 35px;
    font-size: 20px;
  }
  
  .modal-caption {
    padding: 12px;
  }
  
  .modal-caption h3 {
    font-size: 16px;
  }
  
  .modal-caption p {
    font-size: 13px;
  }
}

/* Events Styles */
.events-container {
  width: 100%;
}

.events-container .view-all-container {
  text-align: center;
  margin-top: 24px;
}

.events-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
}

.event-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
}

.event-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #00a0e3;
}

.event-image {
  position: relative;
  height: 110px;
  overflow: hidden;
}

.event-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.event-card:hover .event-image img {
  transform: scale(1.05);
}

.event-date-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(0, 160, 227, 0.9);
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  text-align: center;
  backdrop-filter: blur(10px);
}

.event-month {
  display: block;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 1;
}

.event-day {
  display: block;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  margin-top: 2px;
}

.event-content {
  padding: 12px;
}

.event-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 0 6px 0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.event-description {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
  margin: 0 0 8px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.event-details {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.event-time,
.event-fee {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #555;
}

.event-time .icon-clock,
.event-fee .icon-ticket {
  width: 16px;
  height: 16px;
  opacity: 0.7;
}

.event-actions {
  display: flex;
  justify-content: flex-end;
}

.event-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.event-btn.primary {
  background: #00a0e3;
  color: white;
}

.event-btn.primary:hover {
  background: #0081b8;
  transform: translateY(-1px);
}

/* Responsive Events Grid */
@media (max-width: 1200px) {
  .events-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 900px) {
  .events-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 600px) {
  .events-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 400px) {
  .events-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .event-card {
    border-radius: 6px;
  }
  
  .event-image {
    height: 100px;
  }
  
  .event-content {
    padding: 10px;
  }
  
  .event-title {
    font-size: 13px;
  }
  
  .event-description {
    font-size: 11px;
  }
}

/* Reward and Recognition Enhancements */
.awards-layout {
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
}

.connection-lines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.employee-image-container {
  position: relative;
  display: inline-block;
  z-index: 2;
}

.employee-award-image {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  border: 2px solid #333;
  object-fit: cover;
  transition: all 0.3s ease;
  cursor: pointer;
  background: white;
}

.employee-award-image:hover {
  border-color: #00a0e3;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 160, 227, 0.3);
}

.employee-name-tooltip {
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 10px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 10;
}

.employee-image-container:hover .employee-name-tooltip {
  opacity: 1;
  visibility: visible;
}

/* Award badge positioned styling */
.award-badge-positioned {
  background: #00a0e3;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 9px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  max-width: 120px;
  z-index: 3;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.award-badge-positioned:hover {
  background: #0081b8;
}

/* Enhanced empty placeholders matching reference */
.empty-placeholder {
  width: 50px;
  height: 50px;
  border: 2px solid #ccc;
  border-radius: 6px;
  background: #f5f5f5;
  transition: all 0.3s ease;
}

.empty-placeholder:hover {
  border-color: #00a0e3;
  background: #f0f8ff;
}

/* REAP center positioning */
.reap-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}

/* Responsive adjustments for awards layout */
@media (max-width: 768px) {
  .awards-layout {
    height: 400px;
  }
  
  .employee-award-image {
    width: 40px;
    height: 40px;
  }
  
  .empty-placeholder {
    width: 40px;
    height: 40px;
  }
  
  .award-badge-positioned {
    font-size: 8px;
    padding: 3px 6px;
  }
}

/* Footer Styling */
.footer {
  background-color: #0a3a4a;
  padding: 2.5rem 0;
  color: #fff;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 2px;
}

.footer-logo {
  margin-bottom: 0;
}

.footer-logo-img {
  height: 40px;
  width: auto;
  filter: brightness(0) invert(1);
}

.footer-links {
  display: flex;
  gap: 30px;
  margin: 0;
}

.footer-link {
  color: #00a0e3;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #0081b8;
  text-decoration: underline;
}

.social-icons {
  display: flex;
  gap: 15px;
  margin: 0;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: hsla(0,0%,100%,.1);
  border-radius: 50%;
  color: #fff;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 18px;
}

.social-icon:hover {
  background-color: hsla(0,0%,100%,.2);
  transform: translateY(-2px);
}

.copyright {
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  margin: 0;
}

/* Floating Chat Bot */
.floating-chat-boat {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
}

.chat-boat-btn {
  width: 60px;
  height: 60px;
  border: none;
  border-radius: 50%;
  background-color: #0af;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat-boat-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

.chat-boat-btn:active {
  transform: scale(0.95);
}

.chat-boat-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Profile Dropdown Styling */
.user-avatar {
position: relative;
cursor: pointer;
}

.profile-dropdown-portal {
position: absolute;
top: 110%;
right: -10px;
background: white;
border: 1px solid #e0e0e0;
border-radius: 8px;
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
min-width: 180px;
z-index: 10;
padding: 8px 0;
}

.profile-dropdown-portal .dropdown-arrow {
position: absolute;
top: -8px;
right: 20px;
width: 0;
height: 0;
border-left: 8px solid transparent;
border-right: 8px solid transparent;
border-bottom: 8px solid white;
}

.profile-dropdown-portal .dropdown-item {
display: flex;
align-items: center;
gap: 12px;
width: 100%;
padding: 12px 16px;
border: none;
background: none;
text-align: left;
font-size: 14px;
color: #333;
cursor: pointer;
transition: background-color 0.2s ease;
}

.profile-dropdown-portal .dropdown-item:hover {
background-color: #f8f9fa;
}

.profile-dropdown-portal .dropdown-item.logout {
color: #dc3545;
border-top: 1px solid #e9ecef;
}

.profile-dropdown-portal .dropdown-item.logout:hover {
background-color: #f8f9fa;
}

.dropdown-item i {
font-size: 16px;
width: 16px;
}

.main-header .user-profile .user-avatar .avatar-img{
  border-radius: 50%;
}

/* Responsive Footer */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
  }
  
  .floating-chat-boat {
    bottom: 20px;
    right: 20px;
  }
  
  .chat-boat-btn {
    width: 50px;
    height: 50px;
  }
  
  .chat-boat-icon {
    width: 25px;
    height: 25px;
  }
  
  .profile-dropdown {
    right: -20px;
    min-width: 160px;
  }
}

/* Tab Content Placeholder */
.tab-content-placeholder {
  padding: 40px;
  text-align: center;
  color: #666;
}

.tab-content-placeholder h3 {
  margin-bottom: 10px;
  color: #333;
}

.leave-balance p {
  margin: 0;
  font-size: 12px;
  color: #666;
}

.leave-balance p span { 
  color: #999; 
}

.balance-count {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #005aab !important;
}

.balance-count span { 
  font-size: 14px !important; 
  color: #666 !important; 
}

/* Custom Carousel Dots */
.water-treatment-carousel .slick-dots,
.birthdays-carousel .slick-dots,
.new-joinee-carousel .slick-dots {
  bottom: -40px;
  display: flex !important;
  justify-content: center;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.water-treatment-carousel .slick-dots li,
.birthdays-carousel .slick-dots li,
.new-joinee-carousel .slick-dots li {
  width: auto;
  height: auto;
  margin: 0;
}

.water-treatment-carousel .slick-dots li button,
.birthdays-carousel .slick-dots li button,
.new-joinee-carousel .slick-dots li button {
  display: none;
}

.water-treatment-carousel .custom-dot span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: block;
}

.birthdays-carousel .custom-dot span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(30, 120, 212, 0.4);
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: block;
}

.new-joinee-carousel .custom-dot span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(0, 120, 212, 0.4);
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: block;
}

.water-treatment-carousel .slick-dots li.slick-active .custom-dot span {
  background-color: white;
}

.birthdays-carousel .slick-dots li.slick-active .custom-dot span {
  background-color: #0078d4;
}

.new-joinee-carousel .slick-dots li.slick-active .custom-dot span {
  background-color: #0078d4;
}

.water-treatment-card .card-dots {
  display: flex;
  gap: 8px;
  padding-top: 15px;
  z-index: 1;
  justify-content: center;
}

.water-treatment-card .card-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255,255,255,0.5);
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.water-treatment-card .card-dots span.active {
  background-color: #fff;
}

/* Card Dots */
.card-dots {
  display: flex;
  gap: 8px;
  padding-top: 15px;
  z-index: 1;
}

.card-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #d0d0d0;
}

.card-dots span.active {
  background-color: #0078d4;
}


.water-treatment-card .card-dots span.active {
  background-color: #fff;
}

.main-header .user-profile .user-avatar{
  overflow:visible;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .main-cards-grid {
    flex-direction: column;
    gap: 20px;
  }
  
  .water-treatment-carousel {
    width: 100%;
    max-width: 500px;
  }
  
  .employee-card {
    min-width: auto;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .main-cards-grid {
    padding: 0 15px;
  }
  
  .employee-card {
    flex-direction: column;
    min-height: auto;
  }
  
  .employee-card .birthdays-carousel,
  .employee-card .new-joinee-carousel {
    min-width: auto;
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .employee-card .card {
    min-width: auto;
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .new-joinee-card,
  .birthdays-card,
  .leave-card {
    padding: 15px;
  }
}

/* Search Container */
.search-container {
  position: relative;
}

.search-box {
  position: relative;
}

/* Search Results Dropdown */
.search-results-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
}

.search-results-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.search-result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.search-result-item:last-child {
  border-bottom: none;
}

.search-result-item:hover,
.search-result-item.active {
  background-color: #f8f9fa;
}

.result-info {
  flex: 1 1;
}

.result-name {
  font-weight: 600;
  color: #333;
  margin: 0 0 4px 0;
  font-size: 14px;
}

.result-title {
  color: #666;
  margin: 0 0 4px 0;
  font-size: 12px;
}

.result-contact {
  color: #888;
  margin: 0;
  font-size: 12px;
}

.result-ext {
  background: #e3f2fd;
  color: #1976d2;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

/* CEO Message Dropdown */
.ceo-message-card {
  position: relative;
  cursor: pointer;
  z-index: 1;
}

.ceo-message-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  margin-top: 8px;
  animation: slideDown 0.3s ease-out;
}

@media (max-width: 768px) {
  .info-cards-grid {
    flex-direction: column;
    gap: 16px;
  }
  
  .ceo-message-card {
    position: relative;
    z-index: 10;
  }
  
  .ceo-message-dropdown {
    position: fixed;
    top: auto;
    left: 20px;
    right: 20px;
    bottom: auto;
    z-index: 9999;
    margin-top: 0;
    transform: translateY(0);
  }
  
  .vision-mission-cards {
    position: relative;
    z-index: 1;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ceo-testimonial-card {
  padding: 20px;
}

.testimonial-content {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.testimonial-image {
  flex-shrink: 0;
}

.ceo-photo {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.testimonial-text {
  flex: 1 1;
}

.quote-text {
  position: relative;
  margin-bottom: 16px;
}

.quote-text p {
  font-style: italic;
  color: #555;
  line-height: 1.6;
  margin: 0;
  font-size: 14px;
}

.quote-icon {
  position: absolute;
  top: -8px;
  right: -8px;
}

.quote-icon img {
  width: 24px;
  height: 24px;
  opacity: 0.6;
}

.ceo-info {
  text-align: left;
}

.ceo-name {
  font-weight: 700;
  color: #333;
  font-size: 14px;
  margin-bottom: 4px;
}

.ceo-title {
  color: #666;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/HomePage.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,SAAO;EACP,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;;EAEE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,eAAe,yBAAyB,EAAE;AAC1C,cAAc,yBAAyB,EAAE;AACzC,WAAW,yBAAyB,EAAE;AACtC,gBAAgB,yBAAyB,EAAE;;AAE3C,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,qCAAqC;EACrC,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,4DAA4D;EAC5D,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,2DAA2D;EAC3D,SAAS;EACT,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE;IACE,qCAAqC;IACrC,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA,6CAA6C;AAC7C;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,0CAA0C;EAC1C,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,6BAA6B;AAC7B;AACA,kBAAkB;AAClB,eAAe;AACf;;AAEA;AACA,kBAAkB;AAClB,SAAS;AACT,YAAY;AACZ,iBAAiB;AACjB,yBAAyB;AACzB,kBAAkB;AAClB,yCAAyC;AACzC,gBAAgB;AAChB,WAAW;AACX,cAAc;AACd;;AAEA;AACA,kBAAkB;AAClB,SAAS;AACT,WAAW;AACX,QAAQ;AACR,SAAS;AACT,kCAAkC;AAClC,mCAAmC;AACnC,8BAA8B;AAC9B;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,SAAS;AACT,WAAW;AACX,kBAAkB;AAClB,YAAY;AACZ,gBAAgB;AAChB,gBAAgB;AAChB,eAAe;AACf,WAAW;AACX,eAAe;AACf,sCAAsC;AACtC;;AAEA;AACA,yBAAyB;AACzB;;AAEA;AACA,cAAc;AACd,6BAA6B;AAC7B;;AAEA;AACA,yBAAyB;AACzB;;AAEA;AACA,eAAe;AACf,WAAW;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;;;EAGE,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":["/* Main Cards Section Styles */\n.main-cards-section {\n  padding: 12px 0;\n  background: #f8f9fa;\n}\n\n.main-cards-grid {\n  display: flex;\n  gap: 16px;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0 20px;\n  overflow-x: auto;\n}\n\n/* Water Treatment Carousel */\n.water-treatment-carousel {\n  width: 500px;\n  flex: 0 0 auto;\n}\n\n.water-treatment-carousel .slick-list {\n  margin-bottom: 0;\n}\n\n/* Birthday Carousel */\n.birthdays-carousel {\n  width: 300px;\n  flex: 0 0 auto;\n  min-width: 280px;\n}\n\n.birthdays-carousel .slick-slider {\n  position: relative;\n}\n\n.birthdays-carousel .slick-list {\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.water-treatment-carousel .slick-slider {\n  position: relative;\n}\n\n.water-treatment-carousel .slick-list {\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n/* Water Treatment Card */\n.water-treatment-card {\n  position: relative;\n  background: linear-gradient(135deg, #1e3c72, #2a5298);\n  color: white;\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n  height: 380px;\n  width: 100%;\n}\n\n.water-treatment-card::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to top, #000000 1.37%, rgba(0, 0, 0, 0) 78.02%);\n}\n\n.water-treatment-card:hover {\n  transform: translateY(-2px);\n}\n\n.water-treatment-card .card-content {\n  z-index: 1;\n}\n\n.water-treatment-card .card-content h3 {\n  font-size: 28px;\n  margin-bottom: 10px;\n  color: white;\n}\n\n.water-treatment-card .card-content p {\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 0;\n  max-width: 100%;\n}\n\n/* Carousel Modal Styles */\n.carousel-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.carousel-modal-container {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  width: 100%;\n}\n\n.carousel-modal-close {\n  position: absolute;\n  top: -50px;\n  right: 0;\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  cursor: pointer;\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.carousel-modal-close:hover {\n  background: white;\n}\n\n/* Employee Cards Container */\n.employee-card {\n  background-color: white;\n  display: flex;\n  flex: 1;\n  border-radius: 12px;\n  height: 380px;\n  min-width: 700px;\n  overflow: visible;\n}\n\n.employee-card .birthdays-carousel,\n.employee-card .new-joinee-carousel {\n  flex: 1;\n  border-right: 1px solid #e0e0e0;\n  min-width: 180px;\n  height: 100%;\n}\n\n.employee-card .birthdays-carousel .card,\n.employee-card .new-joinee-carousel .card {\n  border: none;\n  border-radius: 0;\n  height: 100%;\n  background: none;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.employee-card .card {\n  border-right: 1px solid #e0e0e0;\n  background: none;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  border: none;\n  border-radius: 0;\n  flex: 1;\n  min-width: 180px;\n}\n\n.employee-card .card:last-child {\n  border-right: none;\n}\n\n.employee-card .card-dots {\n  justify-content: center;\n  margin-top: auto;\n}\n\n/* Individual Employee Cards */\n.new-joinee-card,\n.birthdays-card {\n  text-align: center;\n  width: 100%;\n}\n\n.leave-card {\n  width: 100%;\n}\n\n.new-joinee-card h4,\n.birthdays-card h4,\n.leave-card h4 {\n  font-size: 18px;\n  color: #333;\n  margin-bottom: 15px;\n}\n\n/* Profile Info Styles */\n.profile-info {\n  text-align: center;\n}\n\n.profile-pic {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  margin: 0 auto 15px;\n}\n\n.profile-info h5 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #005aab;\n  margin-bottom: 5px;\n}\n\n.profile-info p {\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 5px;\n}\n\n.joined-date {\n  color: #0078d4 !important;\n  font-weight: 500 !important;\n}\n\n/* Wish Button */\n.wish-btn {\n  background-color: #00aaff;\n  color: #fff;\n  border: none;\n  border-radius: 20px;\n  padding: 8px 20px;\n  font-size: 14px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.wish-btn .icon-send {\n  font-size: 16px;\n}\n\n.wish-btn:hover {\n  background-color: #0088cc;\n}\n\n/* Calendar Styles */\n.calendar {\n  margin-bottom: 15px;\n}\n\n.calendar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.calendar-header .month-year {\n  font-weight: 600;\n  color: #0078d4;\n}\n\n.calendar-header .nav-arrow {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 0px;\n  text-align: center;\n  font-size: 12px;\n  width: 100%;\n  grid-auto-rows: minmax(30px, auto);\n}\n\n.calendar-grid .day-name {\n  padding: 5px 2px;\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  color: #666;\n}\n\n.calendar-grid .day,\n.calendar-grid .empty-day {\n  padding: 5px;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  font-size: 12px;\n}\n\n.day.today { \n  background-color: #0078d4; \n  color: white; \n  font-weight: bold;\n}\n\n.day.absent { \n  background-color: #28a745; \n  color: white; \n  font-weight: bold;\n}\n\n.day.present { \n  background-color: #e0f2e9; \n}\n\n/* Leave Balance */\n.leave-balance {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #f7f9fa;\n  border-radius: 10px;\n  padding: 10px;\n  margin-top: 15px;\n}\n\n/* Awards Container Styles */\n.awards-container {\n  min-height: 500px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 12px;\n}\n\n.awards-layout {\n  position: relative;\n  width: 100%;\n  height: 500px;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n/* Central REAP Letters */\n.reap-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  gap: 10px;\n}\n\n.reap-letter {\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n  font-size: 24px;\n  border-radius: 8px;\n  position: relative;\n}\n\n.reap-letter span {\n  position: absolute;\n  bottom: -20px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 8px;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.reliability { background-color: #8B4513; }\n.excellence { background-color: #0066CC; }\n.agility { background-color: #8B4513; }\n.perseverance { background-color: #2C3E50; }\n\n/* Employee Award Styles */\n.award-employee {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 2;\n}\n\n.employee-image-container {\n  position: relative;\n  margin-bottom: 10px;\n}\n\n.employee-award-image {\n  width: 60px;\n  height: 60px;\n  border-radius: 8px;\n  object-fit: cover;\n  border: 2px solid #fff;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.employee-award-image:hover {\n  transform: scale(1.1);\n}\n\n.employee-name-tooltip {\n  position: absolute;\n  bottom: -25px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0,0,0,0.8);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n  z-index: 10;\n}\n\n.employee-image-container:hover .employee-name-tooltip {\n  opacity: 1;\n}\n\n.award-badge {\n  background: #0078d4;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 10px;\n  font-weight: bold;\n  text-align: center;\n  max-width: 120px;\n  word-wrap: break-word;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n/* Connecting Lines */\n.connecting-line {\n  position: absolute;\n  width: 2px;\n  height: 40px;\n  background: linear-gradient(to bottom, #0078d4, transparent);\n  top: 70px;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0.6;\n}\n\n.connecting-line::before {\n  content: '';\n  position: absolute;\n  width: 40px;\n  height: 2px;\n  background: linear-gradient(to right, #0078d4, transparent);\n  top: 20px;\n  left: -19px;\n}\n\n/* Empty Award Placeholders */\n.empty-award {\n  position: absolute;\n  z-index: 1;\n}\n\n.empty-placeholder {\n  width: 60px;\n  height: 60px;\n  border: 2px dashed #ccc;\n  border-radius: 8px;\n  background: rgba(255,255,255,0.5);\n}\n\n/* Company Policies Styles */\n.policies-container {\n  width: 100%;\n}\n\n.policies-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  padding-left: 20px;\n  margin-bottom: 20px;\n}\n\n.policy-card {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.policy-card:hover {\n  opacity: 0.8;\n}\n\n.policy-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 0;\n}\n\n.policy-icon {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8f9fa;\n  border-radius: 6px;\n  flex-shrink: 0;\n}\n\n.policy-icon-img {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n}\n\n.policy-header h5 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n  line-height: 1.3;\n  flex: 1;\n}\n\n.policy-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-left: 44px;\n}\n\n.policy-meta {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.policy-category {\n  background: #e3f2fd;\n  color: #1976d2;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.policy-type {\n  color: #666;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.policy-date {\n  color: #888;\n  font-size: 11px;\n}\n\n/* View All Button Styles */\n.view-all-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.view-all-btn {\n  background: #0078d4;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.view-all-btn:hover {\n  background: #106ebe;\n  transform: translateY(-1px);\n}\n\n/* Responsive Design for Policies Grid */\n@media (max-width: 1024px) {\n  .policies-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .policies-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .policy-card {\n    min-height: 120px;\n  }\n}\n\n/* Updates Container */\n.updates-container {\n  width: 100%;\n}\n\n/* Snippets Styles - Same as Updates */\n.snippets-container {\n  width: 100%;\n}\n\n.snippets-list {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px 20px;\n  padding-left: 20px;\n  margin-bottom: 20px;\n}\n\n.snippet-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 8px 0;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.snippet-item:hover {\n  background-color: #f8f9fa;\n}\n\n.snippet-img {\n  width: 60px;\n  height: 60px;\n  border-radius: 8px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.snippet-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.snippet-content h5 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 4px 0;\n  line-height: 1.3;\n}\n\n.snippet-content p {\n  font-size: 14px;\n  color: #666;\n  margin: 0 0 8px 0;\n  line-height: 1.4;\n}\n\n.snippet-meta {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.snippet-type {\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.snippet-type.image {\n  background: #e3f2fd;\n  color: #1976d2;\n}\n\n.snippet-type.video {\n  background: #fce4ec;\n  color: #c2185b;\n}\n\n.snippet-type.ebook {\n  background: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.snippet-date {\n  color: #888;\n  font-size: 12px;\n}\n\n/* Media Modal Styles */\n.media-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 20px;\n}\n\n.media-modal-container {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  background: transparent;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.media-modal-container.video-modal {\n  background: #000;\n}\n\n.media-modal-close {\n  position: absolute;\n  top: -50px;\n  right: 0;\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  cursor: pointer;\n  z-index: 2001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n}\n\n.media-modal-close:hover {\n  background: white;\n}\n\n.modal-image {\n  max-width: 100%;\n  max-height: 70vh;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.modal-video {\n  width: 80vw;\n  height: 45vw;\n  max-width: 1200px;\n  max-height: 675px;\n  min-width: 640px;\n  min-height: 360px;\n}\n\n.modal-caption {\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 16px;\n  margin-top: 10px;\n  border-radius: 8px;\n}\n\n.modal-caption h3 {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.modal-caption p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4;\n  opacity: 0.9;\n}\n\n/* Responsive Snippets Grid */\n@media (max-width: 1024px) {\n  .snippets-list {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 6px 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .snippets-list {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n  \n  .snippet-item {\n    padding: 6px 0;\n  }\n}\n\n/* Responsive Modal */\n@media (max-width: 768px) {\n  .modal-video {\n    width: 90vw;\n    height: 50.6vw;\n    min-width: 320px;\n    min-height: 180px;\n  }\n  \n  .media-modal-close {\n    top: -40px;\n    width: 35px;\n    height: 35px;\n    font-size: 20px;\n  }\n  \n  .modal-caption {\n    padding: 12px;\n  }\n  \n  .modal-caption h3 {\n    font-size: 16px;\n  }\n  \n  .modal-caption p {\n    font-size: 13px;\n  }\n}\n\n/* Events Styles */\n.events-container {\n  width: 100%;\n}\n\n.events-container .view-all-container {\n  text-align: center;\n  margin-top: 24px;\n}\n\n.events-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 12px;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-bottom: 20px;\n}\n\n.event-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 1px solid #f0f0f0;\n}\n\n.event-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  border-color: #00a0e3;\n}\n\n.event-image {\n  position: relative;\n  height: 110px;\n  overflow: hidden;\n}\n\n.event-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.event-card:hover .event-image img {\n  transform: scale(1.05);\n}\n\n.event-date-badge {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: rgba(0, 160, 227, 0.9);\n  color: white;\n  padding: 8px 12px;\n  border-radius: 8px;\n  text-align: center;\n  backdrop-filter: blur(10px);\n}\n\n.event-month {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n  line-height: 1;\n}\n\n.event-day {\n  display: block;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1;\n  margin-top: 2px;\n}\n\n.event-content {\n  padding: 12px;\n}\n\n.event-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 6px 0;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.event-description {\n  font-size: 12px;\n  color: #666;\n  line-height: 1.4;\n  margin: 0 0 8px 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.event-details {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.event-time,\n.event-fee {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  color: #555;\n}\n\n.event-time .icon-clock,\n.event-fee .icon-ticket {\n  width: 16px;\n  height: 16px;\n  opacity: 0.7;\n}\n\n.event-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.event-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.event-btn.primary {\n  background: #00a0e3;\n  color: white;\n}\n\n.event-btn.primary:hover {\n  background: #0081b8;\n  transform: translateY(-1px);\n}\n\n/* Responsive Events Grid */\n@media (max-width: 1200px) {\n  .events-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 900px) {\n  .events-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .events-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 400px) {\n  .events-grid {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n  \n  .event-card {\n    border-radius: 6px;\n  }\n  \n  .event-image {\n    height: 100px;\n  }\n  \n  .event-content {\n    padding: 10px;\n  }\n  \n  .event-title {\n    font-size: 13px;\n  }\n  \n  .event-description {\n    font-size: 11px;\n  }\n}\n\n/* Reward and Recognition Enhancements */\n.awards-layout {\n  position: relative;\n  width: 100%;\n  height: 500px;\n  overflow: hidden;\n}\n\n.connection-lines {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.employee-image-container {\n  position: relative;\n  display: inline-block;\n  z-index: 2;\n}\n\n.employee-award-image {\n  width: 50px;\n  height: 50px;\n  border-radius: 6px;\n  border: 2px solid #333;\n  object-fit: cover;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  background: white;\n}\n\n.employee-award-image:hover {\n  border-color: #00a0e3;\n  transform: scale(1.1);\n  box-shadow: 0 4px 12px rgba(0, 160, 227, 0.3);\n}\n\n.employee-name-tooltip {\n  position: absolute;\n  bottom: -25px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 3px 6px;\n  border-radius: 3px;\n  font-size: 10px;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  z-index: 10;\n}\n\n.employee-image-container:hover .employee-name-tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Award badge positioned styling */\n.award-badge-positioned {\n  background: #00a0e3;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 9px;\n  font-weight: 600;\n  text-align: center;\n  white-space: nowrap;\n  max-width: 120px;\n  z-index: 3;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.award-badge-positioned:hover {\n  background: #0081b8;\n}\n\n/* Enhanced empty placeholders matching reference */\n.empty-placeholder {\n  width: 50px;\n  height: 50px;\n  border: 2px solid #ccc;\n  border-radius: 6px;\n  background: #f5f5f5;\n  transition: all 0.3s ease;\n}\n\n.empty-placeholder:hover {\n  border-color: #00a0e3;\n  background: #f0f8ff;\n}\n\n/* REAP center positioning */\n.reap-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 5;\n}\n\n/* Responsive adjustments for awards layout */\n@media (max-width: 768px) {\n  .awards-layout {\n    height: 400px;\n  }\n  \n  .employee-award-image {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .empty-placeholder {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .award-badge-positioned {\n    font-size: 8px;\n    padding: 3px 6px;\n  }\n}\n\n/* Footer Styling */\n.footer {\n  background-color: #0a3a4a;\n  padding: 2.5rem 0;\n  color: #fff;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n\n.footer-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 2px;\n}\n\n.footer-logo {\n  margin-bottom: 0;\n}\n\n.footer-logo-img {\n  height: 40px;\n  width: auto;\n  filter: brightness(0) invert(1);\n}\n\n.footer-links {\n  display: flex;\n  gap: 30px;\n  margin: 0;\n}\n\n.footer-link {\n  color: #00a0e3;\n  text-decoration: none;\n  font-size: 14px;\n  transition: color 0.3s ease;\n}\n\n.footer-link:hover {\n  color: #0081b8;\n  text-decoration: underline;\n}\n\n.social-icons {\n  display: flex;\n  gap: 15px;\n  margin: 0;\n}\n\n.social-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background-color: hsla(0,0%,100%,.1);\n  border-radius: 50%;\n  color: #fff;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  font-size: 18px;\n}\n\n.social-icon:hover {\n  background-color: hsla(0,0%,100%,.2);\n  transform: translateY(-2px);\n}\n\n.copyright {\n  color: #fff;\n  font-size: 12px;\n  font-weight: 400;\n  margin: 0;\n}\n\n/* Floating Chat Bot */\n.floating-chat-boat {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  z-index: 1000;\n}\n\n.chat-boat-btn {\n  width: 60px;\n  height: 60px;\n  border: none;\n  border-radius: 50%;\n  background-color: #0af;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transition: all 0.3s ease;\n  pointer-events: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chat-boat-btn:hover {\n  transform: scale(1.1);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);\n}\n\n.chat-boat-btn:active {\n  transform: scale(0.95);\n}\n\n.chat-boat-icon {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n/* Profile Dropdown Styling */\n.user-avatar {\nposition: relative;\ncursor: pointer;\n}\n\n.profile-dropdown-portal {\nposition: absolute;\ntop: 110%;\nright: -10px;\nbackground: white;\nborder: 1px solid #e0e0e0;\nborder-radius: 8px;\nbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\nmin-width: 180px;\nz-index: 10;\npadding: 8px 0;\n}\n\n.profile-dropdown-portal .dropdown-arrow {\nposition: absolute;\ntop: -8px;\nright: 20px;\nwidth: 0;\nheight: 0;\nborder-left: 8px solid transparent;\nborder-right: 8px solid transparent;\nborder-bottom: 8px solid white;\n}\n\n.profile-dropdown-portal .dropdown-item {\ndisplay: flex;\nalign-items: center;\ngap: 12px;\nwidth: 100%;\npadding: 12px 16px;\nborder: none;\nbackground: none;\ntext-align: left;\nfont-size: 14px;\ncolor: #333;\ncursor: pointer;\ntransition: background-color 0.2s ease;\n}\n\n.profile-dropdown-portal .dropdown-item:hover {\nbackground-color: #f8f9fa;\n}\n\n.profile-dropdown-portal .dropdown-item.logout {\ncolor: #dc3545;\nborder-top: 1px solid #e9ecef;\n}\n\n.profile-dropdown-portal .dropdown-item.logout:hover {\nbackground-color: #f8f9fa;\n}\n\n.dropdown-item i {\nfont-size: 16px;\nwidth: 16px;\n}\n\n.main-header .user-profile .user-avatar .avatar-img{\n  border-radius: 50%;\n}\n\n/* Responsive Footer */\n@media (max-width: 768px) {\n  .footer-content {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .floating-chat-boat {\n    bottom: 20px;\n    right: 20px;\n  }\n  \n  .chat-boat-btn {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .chat-boat-icon {\n    width: 25px;\n    height: 25px;\n  }\n  \n  .profile-dropdown {\n    right: -20px;\n    min-width: 160px;\n  }\n}\n\n/* Tab Content Placeholder */\n.tab-content-placeholder {\n  padding: 40px;\n  text-align: center;\n  color: #666;\n}\n\n.tab-content-placeholder h3 {\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.leave-balance p {\n  margin: 0;\n  font-size: 12px;\n  color: #666;\n}\n\n.leave-balance p span { \n  color: #999; \n}\n\n.balance-count {\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  color: #005aab !important;\n}\n\n.balance-count span { \n  font-size: 14px !important; \n  color: #666 !important; \n}\n\n/* Custom Carousel Dots */\n.water-treatment-carousel .slick-dots,\n.birthdays-carousel .slick-dots,\n.new-joinee-carousel .slick-dots {\n  bottom: -40px;\n  display: flex !important;\n  justify-content: center;\n  gap: 8px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.water-treatment-carousel .slick-dots li,\n.birthdays-carousel .slick-dots li,\n.new-joinee-carousel .slick-dots li {\n  width: auto;\n  height: auto;\n  margin: 0;\n}\n\n.water-treatment-carousel .slick-dots li button,\n.birthdays-carousel .slick-dots li button,\n.new-joinee-carousel .slick-dots li button {\n  display: none;\n}\n\n.water-treatment-carousel .custom-dot span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.4);\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  display: block;\n}\n\n.birthdays-carousel .custom-dot span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: rgba(30, 120, 212, 0.4);\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  display: block;\n}\n\n.new-joinee-carousel .custom-dot span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: rgba(0, 120, 212, 0.4);\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  display: block;\n}\n\n.water-treatment-carousel .slick-dots li.slick-active .custom-dot span {\n  background-color: white;\n}\n\n.birthdays-carousel .slick-dots li.slick-active .custom-dot span {\n  background-color: #0078d4;\n}\n\n.new-joinee-carousel .slick-dots li.slick-active .custom-dot span {\n  background-color: #0078d4;\n}\n\n.water-treatment-card .card-dots {\n  display: flex;\n  gap: 8px;\n  padding-top: 15px;\n  z-index: 1;\n  justify-content: center;\n}\n\n.water-treatment-card .card-dots span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: rgba(255,255,255,0.5);\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.water-treatment-card .card-dots span.active {\n  background-color: #fff;\n}\n\n/* Card Dots */\n.card-dots {\n  display: flex;\n  gap: 8px;\n  padding-top: 15px;\n  z-index: 1;\n}\n\n.card-dots span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #d0d0d0;\n}\n\n.card-dots span.active {\n  background-color: #0078d4;\n}\n\n\n.water-treatment-card .card-dots span.active {\n  background-color: #fff;\n}\n\n.main-header .user-profile .user-avatar{\n  overflow:visible;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .main-cards-grid {\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .water-treatment-carousel {\n    width: 100%;\n    max-width: 500px;\n  }\n  \n  .employee-card {\n    min-width: auto;\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .main-cards-grid {\n    padding: 0 15px;\n  }\n  \n  .employee-card {\n    flex-direction: column;\n    min-height: auto;\n  }\n  \n  .employee-card .birthdays-carousel,\n  .employee-card .new-joinee-carousel {\n    min-width: auto;\n    border-right: none;\n    border-bottom: 1px solid #e0e0e0;\n  }\n  \n  .employee-card .card {\n    min-width: auto;\n    border-right: none;\n    border-bottom: 1px solid #e0e0e0;\n  }\n  \n  .new-joinee-card,\n  .birthdays-card,\n  .leave-card {\n    padding: 15px;\n  }\n}\n\n/* Search Container */\n.search-container {\n  position: relative;\n}\n\n.search-box {\n  position: relative;\n}\n\n/* Search Results Dropdown */\n.search-results-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.search-results-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.search-result-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.search-result-item:last-child {\n  border-bottom: none;\n}\n\n.search-result-item:hover,\n.search-result-item.active {\n  background-color: #f8f9fa;\n}\n\n.result-info {\n  flex: 1;\n}\n\n.result-name {\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 4px 0;\n  font-size: 14px;\n}\n\n.result-title {\n  color: #666;\n  margin: 0 0 4px 0;\n  font-size: 12px;\n}\n\n.result-contact {\n  color: #888;\n  margin: 0;\n  font-size: 12px;\n}\n\n.result-ext {\n  background: #e3f2fd;\n  color: #1976d2;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* CEO Message Dropdown */\n.ceo-message-card {\n  position: relative;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.ceo-message-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  margin-top: 8px;\n  animation: slideDown 0.3s ease-out;\n}\n\n@media (max-width: 768px) {\n  .info-cards-grid {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .ceo-message-card {\n    position: relative;\n    z-index: 10;\n  }\n  \n  .ceo-message-dropdown {\n    position: fixed;\n    top: auto;\n    left: 20px;\n    right: 20px;\n    bottom: auto;\n    z-index: 9999;\n    margin-top: 0;\n    transform: translateY(0);\n  }\n  \n  .vision-mission-cards {\n    position: relative;\n    z-index: 1;\n  }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ceo-testimonial-card {\n  padding: 20px;\n}\n\n.testimonial-content {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.testimonial-image {\n  flex-shrink: 0;\n}\n\n.ceo-photo {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.testimonial-text {\n  flex: 1;\n}\n\n.quote-text {\n  position: relative;\n  margin-bottom: 16px;\n}\n\n.quote-text p {\n  font-style: italic;\n  color: #555;\n  line-height: 1.6;\n  margin: 0;\n  font-size: 14px;\n}\n\n.quote-icon {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n}\n\n.quote-icon img {\n  width: 24px;\n  height: 24px;\n  opacity: 0.6;\n}\n\n.ceo-info {\n  text-align: left;\n}\n\n.ceo-name {\n  font-weight: 700;\n  color: #333;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n.ceo-title {\n  color: #666;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
